import { CalendarDays, Home, MapPin, Package, Settings } from "lucide-react";

export default function Summary({ data, total }) {
  const rows = [
    ["Moving Type", data.moveType || "Residential Move", Home],
    ["From", data.from || "Not selected", MapPin],
    ["To", data.to || "Not selected", MapPin],
    ["Moving Date", data.date || "Not selected", CalendarDays],
    ["House Type", data.houseType || "Not selected", Home],
    ["Items & Inventory", `${Object.values(data.items || {}).reduce((a, b) => a + b, 0)} items selected`, Package],
    ["Additional Services", `${(data.services || []).length} services selected`, Settings]
  ];

  return (
    <aside className="summary-card">
      <div className="summary-head">
        <div>
          <h3>Your Quote Summary</h3>
          <p>Here's what we have so far. You can review and edit anytime.</p>
        </div>
        <a href="#">Edit All</a>
      </div>

      <div className="summary-list">
        {rows.map(([label, value, Icon]) => (
          <div className="summary-row" key={label}>
            <Icon size={22} />
            <div><strong>{label}</strong><span>{value}</span></div>
            <a href="#">Edit</a>
          </div>
        ))}
      </div>

      <div className="estimate">
        <div className="rupee">₹</div>
        <div><small>Estimated Cost</small><strong>₹ {total.toLocaleString("en-IN")}</strong><span>Final price may vary based on exact requirements.</span></div>
      </div>
    </aside>
  );
}
